import apiClient from '../utils/apiCliente';

/**
 * Consulta el estado actual de un pedido
 * @param {number} pedidoId - ID del pedido a consultar
 * @param {string} token - Token de autenticación
 * @returns {Promise<Object>} - Objeto con estado_id, estado_nombre, payment_id, etc.
 */
export const consultarEstadoPedido = async (pedidoId, token) => {
	if (!pedidoId || !token) {
		throw new Error('pedidoId y token son requeridos');
	}

	try {
		const response = await apiClient.get(`/pedidos/show?id=${pedidoId}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		// Si es error de axios con respuesta
		if (error.response?.status === 401) {
			throw new Error('SESION_EXPIRADA');
		}

		// Re-lanzar el error para que el hook lo maneje
		throw error;
	}
};
